export const appHead = {"meta":[{"charset":"utf-8"},{"name":"theme-color","content":"#16a34a"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"stylesheet","href":"/css/print.css","media":"print"},{"key":"site-fonts","rel":"stylesheet","href":"/css/site-fonts.css?v=1"}],"style":[],"script":[{"key":"analytics-exclusion","tagPriority":-100,"children":"(function analyticsExclusionBootstrap() {\n  var excluded = /(?:^|;\\s*)uo_analytics_excluded=1(?:;|$)/.test(document.cookie);\n  if (excluded || /^\\/admin(?:\\/|$)/.test(location.pathname)) {\n    window['disableYaCounter42914764'] = true;\n  }\n})();"},{"children":"window.yaContextCb=window.yaContextCb||[];"},{"async":true,"src":"https://yandex.ru/ads/system/context.js"},{"async":true,"children":"if(location.hostname!=='127.0.0.1'&&location.hostname!=='localhost')(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-5ZN56KJC');"}],"noscript":[],"viewport":"width=device-width,initial-scale=1","htmlAttrs":{"lang":"ru","class":"xs:scrollbar"},"titleTemplate":"%s"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"